import React from "react";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//     component: React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||"front"||"admin",
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//         component: React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

const frontRoutes = () => [
  {
    path: "/",
    title: "Home",
    component: React.lazy(() => import("../pages/front/Home")),
    layout: "front",
  },
];

const authRoutes = (data) => [
  {
    path: "/signin/admin",
    title: "Admin Login",
    component: React.lazy(() => import("../pages/admin/auth/LogIn")),
    routeType: "auth",
  },
];

const adminRoutes = () => [
  {
    path: "/admin/dashboard",
    title: "dashboard",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/dashboard/Dashboard")),
  },
  {
    path: "/admin",
    title: "Admin List",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/admins/AdminList")),
  },
  {
    path: "/admin/users",
    title: "User List",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/users/UserList")),
  },
  {
    path: "/admin/categories",
    title: "Category List",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() =>
      import("../pages/admin/categories/CategoryList")
    ),
  },
  {
    path: "/admin/hobby",
    title: "Hobby List",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/hobbies/HobbyList")),
  },
  {
    path: "/admin/events",
    title: "Events",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/events/Events")),
  },
  {
    path: "/admin/post",
    title: "Events",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/admin/post/Post")),
  },
  {
    path: "/user/profile",
    title: "Profile",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/user/profile/Profile")),
  },
  {
    path: "/user/hobby",
    title: "Hobby",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/user/hobby/Hobby")),
  },
  {
    path: "/user/home",
    title: "home",
    layout: "admin",
    routeType: "admin",
    component: React.lazy(() => import("../pages/user/home/Home")),
  },
  // {
  //   path: "/admin/post",
  //   title: "Post",
  //   layout: "admin",
  //   routeType: "admin",
  //   component: React.lazy(() => import("../pages/admin/post/Post")),
  // },
];

const userRoutes = () => [];

export const routerData = (data) => {
  return [
    ...userRoutes(data),
    ...adminRoutes(data),
    ...authRoutes(data),
    ...frontRoutes(data),
  ];
};
